import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaCalendarAlt, FaCalendarCheck } from "react-icons/fa";
import RightWrapper from "../../Components/CommonComponents/ComponentWrapper";
import Attendancecount from "./Attendancecount";
import AttendanceRequests from "./Attendancerequests";

// Mark Attendance and Leave Requests share one page; each tab keeps its own
// route so existing links and plan permissions keep working.
const TABS = [
  { key: "attendancecount", label: "Mark Attendance", icon: <FaCalendarCheck /> },
  { key: "attendancerequests", label: "Leave Requests", icon: <FaCalendarAlt /> },
];

const AttendanceLeaves = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const segment = location.pathname.split("/")[1]?.toLowerCase();
  const activeTab = TABS.some((t) => t.key === segment) ? segment : "attendancecount";

  return (
    <RightWrapper>
      <div className="p-4 md:p-6 bg-slate-50 min-h-screen">
        <div className="flex gap-2 mb-6 bg-white rounded-2xl shadow-xs border border-slate-200/80 p-1.5 w-fit">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => navigate(`/${tab.key}`)}
              className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold transition ${
                activeTab === tab.key
                  ? "bg-sky-600 text-white shadow-sm"
                  : "text-slate-600 hover:bg-slate-100"
              }`}
            >
              {tab.icon} {tab.label}
            </button>
          ))}
        </div>

        {activeTab === "attendancecount" ? (
          <Attendancecount embedded />
        ) : (
          <AttendanceRequests embedded />
        )}
      </div>
    </RightWrapper>
  );
};

export default AttendanceLeaves;
